import { MutableRefObject } from "react";
import { LightPointErrorType } from "../../models/LionError";
import { useApiClient } from "../apiClient/apiClient";
import { getParamsURLEncoded } from "../apiParamFactory";
import { FetchLightPointsQuery, GetLightPointsResponse } from "./lightPointsApi.types";

export const useLightPointsApi = (customerScopeRef: MutableRefObject<string|undefined>) => {
  const apiClient = useApiClient();

  /**
   * Fetches lighting points for the current customerScope.
   *
   * @param query - Optional query parameters (only lightingNo is forwarded)
   * @returns Promise resolving to lighting points response
   */
  async function getLightPoints(
    query?: FetchLightPointsQuery,
  ): Promise<GetLightPointsResponse> {
    const params: { lightingNo?: string } = {};
    if (query && "lightingNo" in query && (query as any).lightingNo) {
      params.lightingNo = (query as any).lightingNo;
    }
    const searchParams = getParamsURLEncoded(params, customerScopeRef.current);
    return apiClient.get<GetLightPointsResponse>(
      `v2/lightingpoints/search?${searchParams.toString()}`, LightPointErrorType.FETCH_LIGHTPOINTS
    );
  }

  /**
   * Searches lighting points by asset number within the current customerScope.
   *
   * @param lightingNo - Optional lighting point number
   * @returns Promise resolving to lighting points response
   */
  const searchLightPoints = (lightingNo?: string) => apiClient.get<GetLightPointsResponse>(
    "v2/lightingpoints/search?" + getParamsURLEncoded({ lightingNo }, customerScopeRef.current).toString(),
    LightPointErrorType.FETCH_LIGHTPOINTS
  );

  return {
    getLightPoints,
    searchLightPoints,
  };
};
